import { Transform, TransformFnParams } from 'class-transformer';
import { isValid, parseISO } from 'date-fns';

/**
 * Serialize a date to an ISO date string with the YYYY-MM-DD format without the time part.
 * @param {Date} date - A date object to serialize.
 * @returns {string} A date string in ISO format without the time part.
 */
export function formatISODateOnly(date: Date): string {
  if (!isValid(date)) {
    return null;
  }
  // Parse the ISO string rather than using `formatISO` from date-fns to avoid creating a new date with the local timezone
  const isoString = date.toISOString();
  return isoString.split('T')[0];
}

export function ISODateSerializer(): PropertyDecorator {
  return Transform((params: TransformFnParams) => {
    const { value } = params;

    const dateValue =
      typeof value === 'string' ? parseISO(params.value) : value;
    if (isValid(dateValue)) {
      return formatISODateOnly(dateValue);
    }

    return value;
  });
}
